<div
  class="flex flex-row items-center justify-between gap-4"
  [ngClass]="[type, styleClass]"
  [ngStyle]="{ padding: '1.25rem 1.5rem' }"
>
  <div class="flex flex-row items-center gap-2">
    <ng-content />
  </div>
  <p-button
    *ngIf="closable"
    icon="pi"
    styleClass="p-button-secondary p-button-text p-button-rounded"
    (onClick)="whenClosed.emit(true)"
  >
    <ng-icon name="iconoirCancel" />
  </p-button>
</div>
